import React from 'react';
import * as Cookies from 'js-cookie';
import { StatusCodes } from 'http-status-codes';
import { SubmissionError } from 'redux-form';
import { notification, defaultNoticeConfig } from 'utils/notifications';
import BasicNotification from 'components/Notification';
import { ERROR_5XX_TOASTER, ERROR_403_TOASTER, UNSIGNED_ERROR } from 'constants/errors';
import { flattenKeyPairArray, redirectApp } from 'utils/misc';
import { recursiveFunc } from 'utils/mixins';
import { snakeCase as snakelize, mapKeys, isArray, mapValues } from 'lodash';
import { ON_FAILED_REQUEST } from '../redux/actions/errorsActions';
import { GET_USER_FAIL } from '../redux/actions/userActions';


export const handleErrors = (error, dispatch) => {
  if (error.response.status === StatusCodes.BAD_REQUEST) {
    // pass bad request error to redux form so it can be surfaced there.
    dispatch({
      type: ON_FAILED_REQUEST,
      payload: error.response,
    });
    throw new SubmissionError(error.response.data || {});
  } else if (error.response.status === StatusCodes.UNAUTHORIZED) {
    // redirect user to login
    dispatch({
      type: GET_USER_FAIL,
      payload: error.response,
    });
  } else if (error.response.status === StatusCodes.FORBIDDEN) {
    // handle rest-auth 403
    if (error.response.data.detail === UNSIGNED_ERROR) {
      dispatch({
        type: GET_USER_FAIL,
        payload: error.response,
      });
    } else { // show unauthorized access notification
      dispatch({
        type: ON_FAILED_REQUEST,
        payload: error.response,
      });
      notification.notice({
        content: <BasicNotification
          color="danger"
          message={error.response.data.detail || ERROR_403_TOASTER}
        />,
        ...defaultNoticeConfig,
      });
      throw new Error(error.response || {});
    }
  } else if (error.response.status === StatusCodes.NOT_FOUND) {
    redirectApp('/404');
  } else if (error.appError) {
    notification.notice({
      content: <BasicNotification
        color="danger"
        message={error.message}
      />,
      ...defaultNoticeConfig,
    });
    if (error.log) {
      throw new Error(JSON.stringify(error.message) || {});
    }
  } else {
    // this will cover everything from 405 - 5XX
    dispatch({
      type: ON_FAILED_REQUEST,
      payload: error.response,
    });
    notification.notice({
      content: <BasicNotification
        color="danger"
        message={ERROR_5XX_TOASTER}
      />,
      ...defaultNoticeConfig,
    });
    throw new Error(JSON.stringify(error.response.data) || {});
  }
  return error;
};


export const generateAuthCookies = () => {
  const neededCookies = ['csrftoken'];
  let cookieStr = '';
  neededCookies.forEach((cookieKey) => {
    cookieStr += `${cookieKey}=${Cookies.get(cookieKey)};`;
  });
  return cookieStr;
};


export const serialize = (params, snakeCase = true, flattenArrays = true) => {
  if (snakeCase) {
    // eslint-disable-next-line no-param-reassign
    params = recursiveFunc(mapKeys)(params, (v, k) => snakelize(k));
  }
  if (flattenArrays) {
    // eslint-disable-next-line no-param-reassign
    params = mapValues(params, o => (
      isArray(o) ? flattenKeyPairArray(o, 'value') : o
    ));
  }
  return params;
};
